module.exports = __webpack_public_path__ + "static/img/theme.3718e62a.svg";